import React, { useEffect } from "react";
import ModalWrapper from "./ModalWrapper";
import $ from "jquery";

const PendingStatus = () => {
  useEffect(()=>{
    setTimeout(function () {
      $('#UPIAuthForm').submit();
    }, 4000);
  })
  return (
    <ModalWrapper>
      <div className="pending-container">
        <div className="pendingScreen">
          <img src={`../../${process.env.PUBLIC_URL}/images/WarningCircle.svg`} alt="warningcircles" />
          <p className="failedheading">Payment Pending</p>
          <p className="failedSubLine">
            We are awaiting payment confirmation from your bank. Please wait for
            sometime or retry payment.
            <br />
            In case money is deducted twice, it can be credited back in 2-9
            working days.
          </p>
        </div>
      </div>
    </ModalWrapper>
  );
};

export default PendingStatus;
